
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M19.57 38.7l.01-11.35-9.04-9.12-9.04 9.12V38.7l36.87-.15V15.23L33.41 2.7l-4.96 12.53v23.32"}}),_c('circle',{attrs:{"cx":"10.54","cy":"29.58","r":"2.64","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M10.49 17.66h17.96M19.5 27.39h8.52M29 15.44h9.5"}})])
          )
        }
      }
    